<template>
  <v-dialog v-model="dialog" persistent max-width="400">
    <v-card>
      <v-card-title class="headline"> {{ title }} </v-card-title>
      <vue-cropper
        class="vue-cropper-wrap"
        ref="cropper"
        :src="file"
        alt="Source Image"
        :aspect-ratio="aspectRatio"
      >
      </vue-cropper>
      <div class="actionInputCrop">
        <v-btn-toggle borderless class="btnGroupActionInput">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                @click="$refs.cropper.relativeZoom(0.2)"
              >
                <v-icon>fas fa-plus</v-icon>
              </v-btn>
            </template>
            <span><translate>Zoom In</translate></span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                @click="$refs.cropper.relativeZoom(-0.2)"
              >
                <v-icon>fas fa-minus</v-icon>
              </v-btn>
            </template>
            <span><translate>Zoom Out</translate></span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                @click="$refs.cropper.rotate(-45)"
              >
                <v-icon>fas fa-rotate-left</v-icon>
              </v-btn>
            </template>
            <span><translate>Rotate</translate> -45</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" @click="$refs.cropper.rotate(45)">
                <v-icon>fas fa-rotate-right</v-icon>
              </v-btn>
            </template>
            <span><translate>Rotate</translate> +45</span>
          </v-tooltip>
        </v-btn-toggle>
      </div>
      <v-card-actions class="inputCardAction">
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="dialog = false">
          <translate>Cancel</translate>
        </v-btn>
        <v-btn color="green darken-1" text @click="onCropped"> Ok </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "AvatarUploader",
  props: {
    title: {type: String, default: "Upload Image"},
    file: {},
    aspectRatio: {type: Number, default: 1},
    closeOnCrop: {type: Boolean, default: true},
    force200KB: {type: Boolean, default: false},
    cropOptions: {type: Object, default: () => {}}
  },
  data() {
    return {
      dialog: false,
      cropped: null,
    };
  },
  watch: {
    file(val) {
      this.$nextTick(() => {
        // rebuild cropperjs with the updated source
        this.$refs.cropper.replace(val);
      });
    },
  },
  methods: {
    open(on) {
      this.dialog = on ? true : false;
    },
    async onCropped() {
      if(this.closeOnCrop) {
        this.dialog = false;
      }
      const _this = this
      const croppedCanvas = this.$refs.cropper.getCroppedCanvas(this.cropOptions);
      let finalBlob = await new Promise((resolve, reject) => {
        croppedCanvas.toBlob(
          blob => resolve(blob),
          "image/jpeg"
        );
      });
      if(this.force200KB) {
        const compressedFile = new File([finalBlob], 'vintage', {
          type: "image/jpeg",
          lastModified: Date.now()
        });
        console.log('compressedFile created', compressedFile.size)
        if(compressedFile.size > 200000) {
          const compressRatio = 200000 / compressedFile.size
          console.log(compressRatio)
          finalBlob = await new Promise((resolve, reject) => {
            croppedCanvas.toBlob(
              blob => resolve(blob),
              "image/jpeg",
              compressRatio
            );
          });
        }
      }
      const reader = new FileReader();
      reader.readAsDataURL(finalBlob);
      reader.onload = function (e) {
        _this.$emit("cropped", e.target.result);
      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
    },
  },
};
</script>
<style lang="scss">
//fix for cropper
.vue-cropper-wrap {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  > img {
    display: block;
  }
}

.cropper-container {
  overflow: hidden;
  .cropper-wrap-box {
    background: #555;
  }
}
.actionInputCrop {
  display: flex;
  justify-content: center;
  .btnGroupActionInput {
    flex-direction: row !important;
  }
}
@media all and (max-width: 768px) {
  .inputCardAction {
    justify-content: center;
    .spacer {
      display: none !important;
    }
  }
}
</style>